var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIbanValidationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "published_with_changes_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.097,
    height: 137.746,
    viewBox: "0 0 139.097 137.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2127",
    "data-name": "Rectangle 2127",
    width: 139.097,
    height: 137.746,
    transform: "translate(0)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2176",
    "data-name": "Trac\\xE9 2176",
    d: "M97.206,102.131h13.765V113.6H76.559V79.19H88.03V94.847A45.789,45.789,0,0,0,65.088,13.635V2.05A57.3,57.3,0,0,1,97.206,102.131ZM13.471,59.116A45.6,45.6,0,0,1,30.677,23.385V39.043H42.147V4.631H7.735V16.1H21.5A57.3,57.3,0,0,0,53.618,116.183V104.6A45.907,45.907,0,0,1,13.471,59.116Zm70.2-22.31L51.209,69.268,34.978,53.037l-8.087,8.087L51.209,85.441,91.758,44.893Z",
    transform: "translate(10.541 10.133)",
    fill: "#128ca5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbanValidationIcon);
export default __webpack_public_path__ + "static/media/iban-validation-icon.17c93827.svg";
export { ForwardRef as ReactComponent };